type Listener = () => void;

const listeners = new Set<Listener>();

export function onSessionInvalid(cb: Listener): () => void {
  listeners.add(cb);
  return () => {
    listeners.delete(cb);
  };
}

export function notifySessionInvalid(): void {
  for (const cb of listeners) {
    try {
      cb();
    } catch (err) {
      console.error("Session-invalid listener threw:", err);
    }
  }
}
